module.exports = __webpack_public_path__ + "static/gem-visa-card-w-illustrations-41f9203656a31b11d3f8a7e72ad987de.png";